import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { httpGet, crafterConf } from "@craftercms/classes";
import { composeUrl } from "@craftercms/utils";
import { languagePicker } from '../../utils';
import StaticPageHolder from './StaticPageStyles';
import StaticPageForm from './StaticPageForm';
import SharePage from '../../components/SharePage/SharePage';
import SEO from '../../components/SEO/SEO';

const StaticPage = (props) => {
	const [content, setContent] = useState([]);
	const [thumbnail, setThumbnail] = useState([]);
	const siteURL = window.location.origin;
	const pageURL = window.location.origin + window.location.pathname;
	const pageLang = props.current_lang;
	const pageLocale = pageLang + "_CA";
	const pageTitle = content.title ? content.title + " | CPAC.ca" : "CPAC.ca";
	const pageDesc = content.metaDescription;

	useEffect(() => {
		const craftConf = crafterConf.getConfig();
		const serviceUrl = composeUrl(craftConf, process.env.REACT_APP_CONTENT_MODEL_ENDPOINT);

		httpGet(serviceUrl, { url: props.url, crafterSite: craftConf.site }).subscribe((data) => {
			let fieldNames = ["title_t", "excerpt_html", "content_html", "image_s", "altImageTxt_s", "bottomContent_html", "thumbnailResult.image_s", "thumbnailResult.altImageTxt_s", "metaDescription_t"]
			languagePicker(data, fieldNames);
			setContent(data.page);
			if (data.page.image) {
				setThumbnail(data.page.image)
			} else {
				setThumbnail(data.page.thumbnailResult.item[0].image);
			}
		});
		window.scrollTo(0, 0);

	}, [props.url, props.current_lang]);

	useEffect(() => {
		props.setCurrentLanguage(props.lan);
	}, [props.lan]);

	const selectSchema = () => {
        const { pathname } = window.location;

        switch (pathname) {
            case "/contact-us":
                return "https://schema.org/ContactPage";
            case "/contactez-nous":
                return "https://schema.org/ContactPage";
			case "/video-help":
                return "https://schema.org/ContactPage";
            case "/aide-videos":
                return "https://schema.org/ContactPage";
			case "/accessibility":
				return "https://schema.org/ContactPage";
			case "/accessibilite":
				return "https://schema.org/ContactPage";
            case "/about-cpac":
                return "https://schema.org/AboutPage";
            case "/a-propos-de-cpac":
                return "https://schema.org/AboutPage";
            default:
                return "https://schema.org/WebContent";
        }
    }

	return (
		<>
			<SEO pageDesc={pageDesc} pageURL={pageURL} title={content.title} pageTitle={pageTitle} image={siteURL + thumbnail} pageLocale={pageLocale} />
			<StaticPageHolder>
				 <div itemScope itemType={selectSchema()}>
					<h1 className="page-title" tabIndex="0" itemProp="about">{content.title}</h1>
					<div className="content-wrapper">
						<section id="content" className="content" itemProp="description">
							<div dangerouslySetInnerHTML={{ __html: content.content }} />
							<StaticPageForm />
							{content.bottomContent ? <div className='bottom_content' dangerouslySetInnerHTML={{ __html: content.bottomContent}} /> : ""}
							<SharePage/>
						</section>
						
					</div>
				</div>
			</StaticPageHolder>
		</>
	)
}

const mapStateToProps = ({ language }) => ({
	current_lang: language.current,
});

const mapDispatchToProps = (dispatch) => ({
	setCurrentLanguage: (lang) => dispatch({ type: 'SET_CUR_LANG', current: lang })
});

export default connect(mapStateToProps, mapDispatchToProps)(StaticPage);